import {NgForOf, NgIf} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {PAGES_AND_PATHS} from 'src/app/constants/pages-and-paths';
import {ListsHttpService} from 'src/app/services/http-services/lists/lists-http.service';
import {UserRoles} from '../../../enums/general-enums';
import {CheckActiveRolePipe} from '../../../pipes/check-active-role/check-active-role.pipe';

@Component({
  selector: 'app-listers',
  standalone: true,
  imports: [NgForOf, RouterModule, TranslateModule, CheckActiveRolePipe, NgIf],
  templateUrl: './listers.component.html',
})
export class ListersComponent implements OnInit {
  pageNum = 1;
  favoriteListers: any[] = [];
  PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(private listsHttp: ListsHttpService) {
  }

  ngOnInit(): void {
    this.getFavoriteListersV2()
  }

  getFavoriteListersV2(searchTerm?: string) {
    this.listsHttp.getFavoriteListersV2(this.pageNum, searchTerm).then((response: any) => {
      this.favoriteListers = response.data;
    })
  }

  protected readonly UserRoles = UserRoles;
}
